import { render, staticRenderFns } from "./UserBotEditModal.vue?vue&type=template&id=27d650e3&scoped=true&"
import script from "./UserBotEditModal.vue?vue&type=script&lang=js&"
export * from "./UserBotEditModal.vue?vue&type=script&lang=js&"
import style0 from "./UserBotEditModal.vue?vue&type=style&index=0&id=27d650e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d650e3",
  null
  
)

export default component.exports